import { render, staticRenderFns } from "./VesselSeatPlanForm.vue?vue&type=template&id=6b0a393f"
import script from "./VesselSeatPlanForm.vue?vue&type=script&lang=js"
export * from "./VesselSeatPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports